import { Controller } from "@hotwired/stimulus"

const KEY = "cloud:tree"

// Albero delle cartelle nella colonna sinistra: apri/chiudi rami e ricorda
// la scelta. I rami che portano alla cartella corrente sono aperti dal server.
export default class extends Controller {
  static targets = ["node"]

  connect() {
    const open = this.stored()
    this.nodeTargets.forEach((node) => {
      if (!node.hasAttribute("aria-expanded")) return
      if (open.has(node.dataset.folderId)) this.setOpen(node, true, false)
    })
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    const node = event.currentTarget.closest("[data-cloud-tree-target='node']")
    if (!node) return
    this.setOpen(node, node.getAttribute("aria-expanded") !== "true", true)
  }

  setOpen(node, open, persist) {
    node.setAttribute("aria-expanded", open)
    const children = node.querySelector(":scope > .cloud-rail__children")
    if (children) children.hidden = !open
    if (!persist) return
    const stored = this.stored()
    open ? stored.add(node.dataset.folderId) : stored.delete(node.dataset.folderId)
    try { localStorage.setItem(KEY, JSON.stringify(Array.from(stored))) } catch {}
  }

  stored() {
    try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")) } catch { return new Set() }
  }
}
